import { call, select, put, all, takeLatest } from "redux-saga/effects";
import {
  selectArriveLateDetailData,
  selectFormReqArrivingLateLeaveEarly,
} from "../redux/selector";
import { createReqArriveLateApi } from "core/http/service/timeKeeping";
import {
  updateReqArriveLateFailed,
  updateReqArriveLateStart,
  updateReqArriveLateSuccess,
} from "../redux/updateReqArriveLate";
import { toast } from "react-toastify";
import {
  formReqArrivingLateLeaveEarlyReset,
  resetFormLongTerm,
  TypeSelect,
} from "../redux/formReqArrivingLateLeaveEarly";
import moment from "moment";

function* updateReqArriveLateWork(action) {
  const { screenCode } = action.payload;
  const { data, longTerm } = yield select(selectFormReqArrivingLateLeaveEarly);
  const dataDetail = yield select(selectArriveLateDetailData);

  try {
    const newFormData = {
      ...data,
      id: dataDetail?.id || undefined,
      relatedPersonCodes: data?.relatedPersonCodes?.map((it) => it?.value),
      details: [
        ...(data?.type === TypeSelect.SHORT_TERM
          ? data?.details
              ?.filter(
                (detail) =>
                  dataDetail?.details?.some(
                    (it) =>
                      moment(it?.fromDate)?.toISOString() ===
                        detail?.fromDate?.toISOString() &&
                      detail?.type === it?.type
                  ) &&
                  detail?.reasonCode &&
                  dataDetail?.id === detail?.id
              )
              ?.map((it) => ({
                ...it,
                fromDate: it?.fromDate?.toISOString() ?? "",
                toDate: it?.toDate?.toISOString() ?? "",
              }))
          : [
              {
                fromDate: longTerm?.fromDate?.toISOString(),
                toDate: longTerm?.toDate?.toISOString(),
                minuteAmount: longTerm?.time,
                reasonCode: longTerm?.reason,
                type: longTerm?.typeReq,
              },
            ]),
      ],
    };
    const res = yield call(createReqArriveLateApi, newFormData, screenCode);
    if (res) {
      yield put({
        type: updateReqArriveLateSuccess.type,
      });
      yield put({
        type: resetFormLongTerm.type,
      });
      yield put({
        type: formReqArrivingLateLeaveEarlyReset.type,
      });

      // yield put({
      //   type: getListArriveLateStart.type,
      //   payload: {
      //     year: moment().year(),
      //     month: moment().month() + 1,
      //     limit: 60,
      //     offset: 0,
      //     screenCode,
      //   },
      // });
      action.payload?.callback?.();
      toast.success("Đơn của bạn đã được gửi thành công!");
    }
  } catch (err: any) {
    yield put({
      type: updateReqArriveLateFailed.type,
    });
    toast.error(
      err?.response?.data?.message || "Đã có lỗi xảy ra lúc tạo đơn!"
    );
  }
}

function* watchCreateReqArriveLate() {
  yield takeLatest(updateReqArriveLateStart.type, updateReqArriveLateWork);
}

export default function* updateReqArriveLateSaga() {
  yield all([watchCreateReqArriveLate()]);
}
